export const gamBannerSizes: string[] = unique(
  [
    // Sizes from IAB
    [970, 250],
    [300, 50],
    [320, 50],
    [728, 90],
    [970, 90],
    [300, 1050],
    [160, 600],
    [300, 250],
    [20, 60],
    [120, 60],
    [640, 1136],
    [750, 1334],
    [1080, 1920],
    [120, 20],
    [168, 28],
    [216, 36],
    // Sizes from GAM
    [88, 31],
    [120, 30],
    [120, 60],
    [120, 90],
    [120, 240],
    [120, 600],
    [125, 125],
    [160, 600],
    [168, 28],
    [168, 42],
    [180, 150],
    [188, 141],
    [200, 200],
    [200, 446],
    [216, 36],
    [216, 54],
    [220, 90],
    [234, 60],
    [240, 133],
    [240, 400],
    [250, 250],
    [250, 360],
    [292, 30],
    [300, 31],
    [300, 50],
    [300, 75],
    [300, 100],
    [300, 300],
    [300, 600],
    [300, 1050],
    [320, 50],
    [320, 100],
    [320, 240],
    [320, 480],
    [336, 280],
    [468, 60],
    [480, 320],
    [570, 427],
    [580, 400],
    [728, 90],
    [750, 100],
    [750, 200],
    [750, 300],
    [768, 1024],
    [930, 180],
    [950, 90],
    [960, 90],
    [970, 66],
    [970, 90],
    [970, 250],
    [980, 90],
    [980, 120],
    [1024, 768],
  ]
    .sort((a, b) => {
      const aWidthIsBigger = a[0] > b[0]
      const aWidthIsSmaller = a[0] < b[0]
      if (aWidthIsBigger) {
        return 1
      }
      if (aWidthIsSmaller) {
        return -1
      }
      const aHeightIsBigger = a[1] > b[1]
      return aHeightIsBigger ? 1 : -1
    })
    .map((size) => size.join('x'))
)

function unique<T>(array: T[]): T[] {
  return Array.from(new Set(array))
}
